export default __webpack_public_path__ + "static/media/SWT1640.34I-38644_-22615_0.91879994.jpg";